import "./RequestMainInformation.css";
import DateObject from "react-date-object";
import PumperList from "../features/PumperList/PumperList";

function pluralizeDays(n) {
  const abs = Math.abs(n);
  const lastTwo = abs % 100;
  const lastOne = abs % 10;

  if (lastTwo >= 11 && lastTwo <= 19) return `${n} дней`;
  if (lastOne === 1) return `${n} день`;
  if (lastOne >= 2 && lastOne <= 4) return `${n} дня`;
  return `${n} дней`;
}

function hasValue(v) {
  return (
    v === null ||
    v === undefined ||
    v === "" ||
    (Array.isArray(v) && v.length === 0)
  );
}

function InfoItem({ title, children, value }) {
  if (hasValue(value ?? children)) return null;
  return (
    <div className="requestInfoElement">
      <span className="requestInfoTitle">{title}</span>
      <span className="requestInfoValue">{children ?? value}</span>
    </div>
  );
}

function RequestMainBossInformation({ request, creditData }) {
  let date = new DateObject();

  date._format = "DD.MM.YY";
  date = date.parse(request.date);

  date.months = [
    ["jan", "Января"],
    ["feb", "Февраля"],
    ["mar", "Марта"],
    ["apr", "Апреля"],
    ["may", "Мая"],
    ["jun", "Июня"],
    ["jul", "Июля"],
    ["aug", "Августа"],
    ["sep", "Сентября"],
    ["oct", "Октября"],
    ["nov", "Ноября"],
    ["dec", "Декабря"],
  ];

  return (
    <div style={{ paddingTop: "10px" }} className="requestInfoContainer">
      <div className="requestInforamtionContainer">
        <h2 className="requestInformationTitle">Контрагент</h2>
        <div className="requestInformationList">
          {!hasValue(request?.counterpart) && (
            <InfoItem title="Клиент" value={request.counterpart} />
          )}
          {!hasValue(request.address) && (
            <InfoItem title="Адрес" value={request.address} />
          )}
          {!hasValue(creditData?.manager) && (
            <InfoItem title="Основной менеджер" value={creditData?.manager} />
          )}
        </div>
      </div>
      <div className="requestInforamtionContainer">
        <h2 className="requestInformationTitle">Финансы</h2>
        <div className="requestInformationList">
          {!hasValue(creditData?.debitValue) && (
            <InfoItem title={creditData.debitValue > 0 ? "ДЗ" : "Предоплата"}>
              {Math.abs(creditData.debitValue).toLocaleString("ru")} ₽
            </InfoItem>
          )}
          {!hasValue(creditData?.overdueDebitValue) && (
            <InfoItem title="ПДЗ">
              {Math.abs(creditData.overdueDebitValue).toLocaleString("ru")} ₽
            </InfoItem>
          )}
          {!hasValue(creditData?.overdueDebitDelayValue) && (
            <InfoItem title="Просрочка">
              {pluralizeDays(creditData.overdueDebitDelayValue)}
            </InfoItem>
          )}
          {!hasValue(creditData?.maxOverdueDays) && (
            <InfoItem title="Отсрочка">
              {pluralizeDays(creditData.maxOverdueDays)}
            </InfoItem>
          )}
        </div>
      </div>
      <div className="requestInforamtionContainer">
        <h2 className="requestInformationTitle">Лимиты</h2>
        <div className="requestInformationList">
          {!hasValue(creditData?.limitValue) && (
            <InfoItem title="Лимит">
              {Math.abs(creditData.limitValue).toLocaleString("ru")} ₽
            </InfoItem>
          )}
          {!hasValue(creditData?.limitOverrun) && (
            <InfoItem title="Превышение">
              {Math.abs(creditData.limitOverrun).toLocaleString("ru")} ₽
            </InfoItem>
          )}
          {!hasValue(creditData?.allOrdersAmount) && (
            <InfoItem title="Сумма заявок">
              {Math.abs(creditData.allOrdersAmount).toLocaleString("ru")} ₽
            </InfoItem>
          )}
          {!hasValue(creditData?.limitOverrunWithOrders) && (
            <InfoItem title="Превышение с учетом заявок">
              {Math.abs(creditData.limitOverrunWithOrders).toLocaleString("ru")}{" "}
              ₽
            </InfoItem>
          )}
          {!hasValue(creditData?.blockedOrdersValue) && (
            <InfoItem title="Сумма заблокированных заявок">
              {Math.abs(creditData.blockedOrdersValue).toLocaleString("ru")} ₽
            </InfoItem>
          )}
          {!hasValue(creditData?.limitOverrunWithBlockedOrdersValue) && (
            <InfoItem title="Превышение с учетом всех заявок">
              {Math.abs(
                creditData.limitOverrunWithBlockedOrdersValue,
              ).toLocaleString("ru")}{" "}
              ₽
            </InfoItem>
          )}
        </div>
      </div>
      <div className="requestInforamtionContainer">
        <h2 className="requestInformationTitle">Контроль</h2>
        <div className="requestInformationList">
          {!hasValue(creditData?.shippableVolume) && (
            <InfoItem title="Доступно к отгрузке по лимиту">
              {Math.abs(creditData.shippableVolume).toLocaleString("ru")} м³
            </InfoItem>
          )}
          {!hasValue(creditData?.limitControlByContracts) && (
            <InfoItem
              title="Лимиты"
              value={
                creditData?.limitControlByContracts
                  ? "c учетом договоров"
                  : "без учета договоров"
              }
            />
          )}
          {!hasValue(creditData?.delayControlByContracts) && (
            <InfoItem
              title="Отсрочка"
              value={
                creditData?.delayControlByContracts
                  ? "c учетом договоров"
                  : "без учета договоров"
              }
            />
          )}
          {!hasValue(creditData?.contract) && (
            <InfoItem title="Договор" value={creditData.contract} />
          )}
        </div>
      </div>
      <div className="requestInforamtionContainer">
        <h2 className="requestInformationTitle">Заявка</h2>
        <div className="requestInformationList">
          {!hasValue(request.nomenclature) && (
            <InfoItem title="Номенклатура" value={request.nomenclature} />
          )}
          {!hasValue(request.capacity) && (
            <InfoItem title="Объем, м³" value={request.capacity} />
          )}
          {!hasValue(request.date) && (
            <InfoItem title="Дата">{date.format("DD MMM YYYY")}</InfoItem>
          )}
          {!hasValue(request.time) && (
            <InfoItem title="Время" value={request.time} />
          )}
          {!hasValue(creditData?.orderAmount) && (
            <InfoItem
              title="Сумма"
              value={
                Math.abs(creditData.orderAmount).toLocaleString("ru") + " ₽"
              }
            />
          )}
          {!hasValue(request.cone_draft) && (
            <InfoItem title="Осадка конуса, см" value={request.cone_draft} />
          )}
          {!hasValue(request.acceptance_method) && (
            <InfoItem
              title="Способ отгрузки"
              value={request.acceptance_method}
            />
          )}

          {!hasValue(request.acceptance_method) &&
            request.acceptance_method === "Насос" && (
              <InfoItem
                title="Параметры насоса"
                value={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <span className="requestInfoValue">
                      под заказ: {request.ownPumps}
                    </span>
                    <span className="requestInfoValue">
                      свои: {request.contractorPumps}
                    </span>
                  </div>
                }
              />
            )}

          {!hasValue(request.pumpDescriptions) && (
            <InfoItem
              title="Насосы под заказ"
              value={<PumperList data={request.pumpDescriptions} />}
            />
          )}

          {!hasValue(request.interval) && (
            <InfoItem title="Интервал" value={request.interval} />
          )}
          {!hasValue(request.intensity) && (
            <InfoItem title="Интенсивность м³/ч" value={request.intensity} />
          )}
          {!hasValue(request.pmd) && (
            <InfoItem title="ПМД" value={request.pmd} />
          )}
          {!hasValue(request.phone_number) && (
            <InfoItem
              title="Принимает на объекте"
              value={request.phone_number}
            />
          )}
          {!hasValue(request.customerPhoneNumber) && (
            <InfoItem
              title="Завел заявку"
              value={request.customerPhoneNumber}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default RequestMainBossInformation;
